import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('CoinIcon').create(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    borderRadius: '50%',

    img: {
      width: '100%',
      height: '100%',
    },
  },
}))
